import { render, staticRenderFns } from "./xiaomiUserAgreement.vue?vue&type=template&id=615679a5&scoped=true&"
var script = {}
import style0 from "./xiaomiUserAgreement.vue?vue&type=style&index=0&id=615679a5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "615679a5",
  null
  
)

export default component.exports